import React from "react";
import Sugar from "sugar";

import { withRouter } from 'react-router-dom';
// import { useData } from "./data/DataHooks";
import { isSameScorecard, isSameMajor } from "./Helpers.js";

import PymFrame from './core/PymFrame';
import InlineScorecard from './scorecard/InlineScorecard';
import ScorecardPlaceholder from './scorecard/ScorecardPlaceholder';
import GraphicWrapper from './GraphicWrapper';
import Credits from './Credits';

import { useScorecardData } from "./data/DataHooks";

import "./assets/scss/App.scss";

Sugar.extend()



function WidgetScorecards({ match }) {

  // const collegeData = useData();
  const search = match.params;
  let { unitid, cipCode, degreeLevel } = search;
  // let { scorecard, majors } = useScorecardData( unitid, cipCode, degreeLevel );

  // const scorecard = collegeData.find( data => isSameScorecard( data, search ) );
  // const majors = collegeData.filter( data=> isSameMajor( data, search ) );

  const result = search ? <InlineScorecard source={ `${ cipCode }-${degreeLevel}`} data={search} /> : <div className="inline-scorecard"><ScorecardPlaceholder/></div>;

  return (
    <PymFrame>
      <GraphicWrapper>
        { result }
        <Credits/>
      </GraphicWrapper>
    </PymFrame>
  )
}

export default withRouter( WidgetScorecards );
